import { pumkinAPI } from "@api";
import { IConClose, PointPIcon } from "@components";
import { PATH_HOME, PATH_REGISTER_WARRANTY } from "@configs";
import { selectAuth, selectMerchant } from "@redux";
import { useNotify } from "@utils";
import { Tabs } from "antd";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useCache from "src/Store/useCache";
import styled from "styled-components";
import { IconBarCode } from "../icon/BarCode";
import { IconCheck } from "../icon/Check";
import { IconStroke } from "../icon/IconStroke";
import { PinIcon } from "../icon/Pin";
import { BackIcon } from "../icon/TopSpender/BackIcon";
import PopupWarrantyDesc from "./PopupWarrantyDesc";

const { TabPane } = Tabs;

export const ComponentWarrantyList = () => {
    const userInfo = useSelector(selectAuth);
    const listInnerRef = useRef<HTMLDivElement | null>(null);
    const qrRef = useRef();
    const { success, error, warning } = useNotify();
    const history = useHistory();
    const [tab, setTab] = useState<string>("1");
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor;
    const [page, setPage] = useState<number>(1);
    const [warrantyList, setWarrantyList] = useState<any[]>([]);
    const [dataClick, setDataClick] = useState<any>({});
    const [dataCondition, setDataCondition] = useState<any>({});
    const [dataNote, setDataNote] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedDetail, setSelectedDetail] = useState<"conditions" | "notes" | null>(null);
    const [isDetailTools, setDetailTools] = useState<boolean>(false);
    // const [warrantyList, setWarrantyList] = useState(mockWarrantyList);

    const getWarrantyList = async (status: string) => {
        try {
            useCache.setState({ isLoading: true });
            const getList = await pumkinAPI.getWarrantyList({
                status: status,
                limit: 10,
                page: page,
                user_id: userInfo?.userInfo?._id,
            });
            if (getList.data) {
                setWarrantyList(getList.data?.data ? getList.data?.data : []);
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        } finally {
            useCache.setState({ isLoading: false });
        }
    };

    useEffect(() => {
        getWarrantyList(tab === "1" ? "PENDING" : tab === "2" ? "APPROVE" : "REJECT");
    }, [tab, page]);
    // useEffect(() => {
    //     // จำลองการ fetch ข้อมูลจาก API
    //     setTimeout(() => {
    //         setWarrantyList(mockWarrantyList);
    //     }, 1000); // หน่วงเวลา 1 วินาที
    // }, []);

    const resetStates = () => {
        setDetailTools(false);
        setDataClick({});
    };

    function callback(items: any) {
        setWarrantyList([]);
        setTab(items);
        setPage(1);
    }

    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10 && !loading) {
                if (page * 10 === warrantyList?.length) {
                    setPage((prevPage) => prevPage + 1);
                }

                // This will be triggered after hitting the last element.
                // API call should be made here while implementing pagination.
            }
        }
    };

    return (
        <StyledContainer color={themes?.themeColor!}>
            <div className="container">
                <div className="backIcon" onClick={() => history.push(PATH_HOME)}>
                    <BackIcon color={"#FFF"} />
                    <h2>รับประกันออนไลน์</h2>
                    <p> </p>
                </div>
                <div className="content">
                    <Tabs defaultActiveKey="1" activeKey={tab} onChange={callback}>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "1" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    รอดำเนินการ
                                </span>
                            }
                            key="1"
                            style={{ overflow: "auto" }}
                        >
                            <div className="contentRow" onScroll={onScroll} ref={listInnerRef}>
                                {warrantyList?.map((item: any) => {
                                    if (item?.status === "PENDING") {
                                        return (
                                            <div
                                                className="listColumn"
                                                onClick={() => {
                                                    setDataClick(item);
                                                    setDetailTools(true);
                                                    // setShowPopup(true);
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="textCode">
                                                        <span>
                                                            <IconBarCode />
                                                        </span>{" "}
                                                        {item?.serial_number}
                                                    </div>
                                                    <div className="textDate">
                                                        {format(
                                                            new Date(item?.purchase_date),
                                                            "DD/MM/YYYY"
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="divider"></div>
                                                <div className="textName">{item?.product_name}</div>
                                                <div className="textModel">
                                                    รุ่น {item?.product_model || "-"}
                                                </div>
                                                <div className="row">
                                                    <div className="textAddress">
                                                        <span>
                                                            <PinIcon />
                                                        </span>{" "}
                                                        {item?.store}, {item?.channel}
                                                    </div>
                                                    <div className="textStatusPending">
                                                        <span>
                                                            <img src="../images/pendingIcon.svg" />
                                                        </span>{" "}
                                                        รอดำเนินการ
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "2" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    อนุมัติแล้ว
                                </span>
                            }
                            key="2"
                        >
                            <div className="contentRow" onScroll={onScroll} ref={listInnerRef}>
                                {warrantyList?.map((item: any) => {
                                    if (item?.status === "APPROVE") {
                                        return (
                                            <div
                                                className="listColumn"
                                                onClick={() => {
                                                    setDataClick(item);
                                                    setDetailTools(true);
                                                    // setShowPopup(true);
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="textCode">
                                                        <span>
                                                            <IconBarCode />
                                                        </span>{" "}
                                                        {item?.serial_number}
                                                    </div>
                                                    <div className="textDate">
                                                        {item?.approve_date &&
                                                            format(
                                                                new Date(item?.approve_date),
                                                                "DD/MM/YYYY HH:mm"
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="divider"></div>
                                                <div className="textName">
                                                    {item?.product_name || "-"}
                                                </div>
                                                <div className="textModel">
                                                    รุ่น {item?.product_model || "-"}
                                                </div>
                                                <div className="row">
                                                    <div className="textAddress">
                                                        <span>
                                                            <PinIcon />
                                                        </span>{" "}
                                                        {item?.store}, {item?.channel}
                                                    </div>
                                                    <div className="textStatus">
                                                        {item?.PointsAwarded && (
                                                            <span>
                                                                <PointPIcon /> +
                                                                {item?.PointsAwarded}{" "}
                                                                <span style={{ marginLeft: "5px" }}>
                                                                    <IconStroke />
                                                                </span>
                                                            </span>
                                                        )}
                                                        <span>
                                                            <IconCheck size={16} />
                                                        </span>{" "}
                                                        อนุมัติแล้ว
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "3" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    ไม่อนุมัติ
                                </span>
                            }
                            key="3"
                        >
                            <div className="contentRow" onScroll={onScroll} ref={listInnerRef}>
                                {warrantyList?.map((item: any) => {
                                    if (item?.status === "REJECT") {
                                        return (
                                            <div
                                                className="listColumn"
                                                onClick={() => {
                                                    setDataClick(item);
                                                    setDetailTools(true);
                                                    // setShowPopup(true);
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="textCode">
                                                        <span>
                                                            <IconBarCode />
                                                        </span>{" "}
                                                        {item?.serial_number}
                                                    </div>
                                                    <div className="textDate">
                                                        {item?.approve_date &&
                                                            format(
                                                                new Date(item?.approve_date),
                                                                "DD/MM/YYYY HH:mm"
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="divider"></div>
                                                <div className="textName">
                                                    {item?.product_name || "-"}
                                                </div>
                                                <div className="textModel">
                                                    รุ่น {item?.product_model || "-"}
                                                </div>
                                                <div className="row">
                                                    <div className="textAddress">
                                                        <span>
                                                            <PinIcon />
                                                        </span>{" "}
                                                        {item?.store}, {item?.channel}
                                                    </div>
                                                    <div className="textStatusReject">
                                                        {/* <span>
                                                    <IconCheck size={16} />
                                                </span>{" "} */}
                                                        ไม่อนุมัติ
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                    </Tabs>
                    <div className="maim-layout-upload-warranty">
                        <div className="img-upload-warranty">
                            <img src="../../images/toolsbox.png" alt="" />
                        </div>
                        <StyledBtnUploadActivity
                            className="btn-redeem"
                            themeColor={themes?.themeColor!}
                            onClick={() => history.push(PATH_REGISTER_WARRANTY)}
                        >
                            + ลงทะเบียนรับประกันออนไลน์
                        </StyledBtnUploadActivity>
                    </div>
                </div>
            </div>
            {isDetailTools && (
                <StyledShowPopup themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div className="close" onClick={resetStates}>
                            <IConClose width={16} />
                        </div>
                        <div className="content-layout">
                            <div className="img-detail-tools">
                                <img src={dataClick?.warranty_image || " "} alt="" />
                            </div>
                            <div className="title-details-tools">
                                <h2>{dataClick?.product_name || "-"}</h2>
                            </div>
                            <TableContainer>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <FaMapMarkerAlt color="#f56c6c" /> หน้าร้าน
                                            </td>
                                            <td className="text-center">
                                                {dataClick?.store || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>รหัสสินค้า</td>
                                            <td className="text-center">
                                                {dataClick?.product_code || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>รุ่น</td>
                                            <td className="text-center">
                                                {dataClick?.product_model || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>เลขซีเรียล</td>
                                            <td className="text-center">
                                                {dataClick?.serial_number || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>วันที่ซื้อสินค้า</td>
                                            <td className="text-center">
                                                {dataClick?.purchase_date && <FaCalendarAlt />}
                                                {dataClick?.purchase_date
                                                    ? format(
                                                          new Date(dataClick?.purchase_date),
                                                          "DD/MM/YYYY"
                                                      )
                                                    : "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>วันหมดอายุ</td>
                                            <td className="text-center">
                                                {dataClick?.expire_warranty_date && (
                                                    <FaCalendarAlt />
                                                )}
                                                {dataClick?.expire_warranty_date
                                                    ? format(
                                                          new Date(dataClick?.expire_warranty_date),
                                                          "DD/MM/YYYY"
                                                      )
                                                    : " "}{" "}
                                                <WarrantyRemaining>
                                                    {/* cal expired date */}
                                                    {dataClick?.expireDuration === "infinity"
                                                        ? "กำลังตรวจสอบ"
                                                        : dataClick?.expireDuration === "expired"
                                                        ? "หมดเขตรับประกัน"
                                                        : "เหลืออีก " +
                                                          dataClick?.expireDuration +
                                                          " วัน"}
                                                </WarrantyRemaining>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>ระยะเวลารับประกัน</td>
                                            <td className="text-center">
                                                {dataClick?.warranty_duration_month
                                                    ? dataClick?.warranty_duration_month + " เดือน"
                                                    : "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>เงื่อนไขรับประกัน</td>
                                            <td>
                                                {Array.isArray(dataClick?.condition) &&
                                                dataClick?.condition.length > 0 ? (
                                                    <ul>
                                                        {dataClick?.condition.map(
                                                            (item: string, index: number) => (
                                                                <li key={index}>{item}</li>
                                                            )
                                                        )}
                                                    </ul>
                                                ) : (
                                                    <div className="text-center">-</div>
                                                )}

                                                {Array.isArray(dataClick?.condition) &&
                                                    dataClick?.condition.length > 0 && (
                                                        <div
                                                            className="readmore"
                                                            onClick={() => {
                                                                setSelectedDetail("conditions");
                                                                setDataCondition(
                                                                    dataClick?.condition
                                                                );
                                                            }}
                                                        >
                                                            อ่านต่อ
                                                        </div>
                                                    )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>หมายเหตุรับประกัน</td>
                                            <td>
                                                {Array.isArray(dataClick?.remark) &&
                                                dataClick?.remark.length > 0 ? (
                                                    dataClick?.remark.map(
                                                        (item: string, index: number) => (
                                                            <Note key={index}>⚠️ {item}</Note>
                                                        )
                                                    )
                                                ) : (
                                                    <div className="text-center">-</div>
                                                )}
                                                {Array.isArray(dataClick?.remark) &&
                                                    dataClick?.remark.length > 0 && (
                                                        <div
                                                            className="readmore"
                                                            onClick={() => {
                                                                setSelectedDetail("notes");
                                                                setDataNote(dataClick?.remark);
                                                            }}
                                                        >
                                                            อ่านต่อ
                                                        </div>
                                                    )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </StyledShowPopup>
            )}
            {selectedDetail && (
                <StyledShowPopup themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div className="back" onClick={() => setSelectedDetail(null)}>
                            <BackIcon color={"#000"} />
                        </div>
                        {/* <div className="close" onClick={resetStates}>
                            <IConClose width={16} />
                        </div> */}
                        <div className="content-layout">
                            {selectedDetail === "conditions" ? (
                                <>
                                    <h3>เงื่อนไขการรับประกัน</h3>
                                    <ul>
                                        {dataCondition.map((item: string, index: number) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <>
                                    <h3>หมายเหตุรับประกัน</h3>
                                    <ul>
                                        {dataNote.map((item: string, index: number) => (
                                            <li key={index}>⚠️ {item}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </StyledShowPopup>
            )}
            {isShowPopup && (
                <PopupWarrantyDesc
                    onClose={() => setShowPopup(false)}
                    data={dataClick}
                    status={
                        tab === "1" ? "รอดำเนินการ" : tab === "2" ? "อนุมัติแล้ว" : "ไม่อนุมัติ"
                    }
                />
            )}
        </StyledContainer>
    );
};

const StyledShowPopup = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        min-height: 55%;
        background-color: #fff;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        .close {
            position: absolute;
            right: 18px;
            top: 18px;
            z-index: 1;
        }
        .back {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .content-layout {
        height: auto;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        /* padding-top: 24px;
        padding-bottom: 24px; */
        padding: 48px 24px;
        min-height: 60%;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .edit-sub-text {
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #f2a808;
            margin-bottom: 12px;
        }
        .img-detail-tools {
            width: 140px;
            height: 140px;
            border-radius: 100%;
            overflow: hidden;
            text-align: center;
            margin: 0 auto;
            position: relative;
            margin-top: -90px;
            background-color: #fff;
            margin-bottom: 25px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .title-details-tools {
            h2 {
                font-size: 18px;
                font-weight: 600;
                line-height: 21px;
                color: #000;
                margin-bottom: 16px;
                text-align: center;
            }
        }
    }
`;

const TableContainer = styled.div`
    width: 100%;
    max-width: 600px;
    margin: auto;
    border-radius: 12px;
    overflow: hidden;
    background: #fef7f5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    .text-center {
        text-align: center;
    }
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    td,
    th {
        padding: 12px;
        border-bottom: 1px solid #eee;
    }

    td:first-child {
        width: 35%;
        text-align: center;
        border-right: 1px solid #eee;
    }
`;

const WarrantyRemaining = styled.span`
    color: #d9534f;
    background: #fdecea;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
`;

const Note = styled.div`
    font-size: 12px;
    color: #ff9800;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const StyledContainer = styled.div<{ color: string }>`
    height: 100dvh;
    background-color: ${(p) => p.color};
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 500;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: ${(p) => p.color};
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 5px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }
    .container {
        .backIcon {
            display: flex;
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
            align-items: center;
            justify-content: space-between;
            width: 80%;
        }
        h2 {
            color: #fff;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .maim-layout-upload-warranty {
        border-radius: 16px 16px 0px 0px;
        background: linear-gradient(357deg, #231f20 2.11%, #ff5120 237.93%);
        padding: 46px 16px 12px;
        position: fixed;
        bottom: 0;
        width: 100%;
        max-width: 480px;
        height: 100px;
        left: 50%;
        transform: translateX(-50%);
        .img-upload-warranty {
            position: absolute;
            top: -90px;
            left: 50%;
            transform: translateX(-50%);
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        h3 {
            font-size: 12px;
            color: #525257;
            margin-bottom: 10px;
            text-align: center;
        }
    }
    .content {
        width: 100%;
        height: 90dvh;
        background-color: rgba(246, 246, 246, 1);
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 9px 16px 0px 16px;

        .ant-tabs-nav {
            .ant-tabs-tab {
                padding: 0;
                margin: 0px 10px 10px 0px !important;
                width: 95px;
                height: 35px;
                span {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }
        .contentRow {
            display: flex;
            flex-direction: column;
            gap: 6px;
            position: relative;
            overflow: auto;
            height: 70dvh;
            padding-bottom: 20px;
        }
        .listColumn {
            display: flex;
            flex-direction: column;
            padding: 10px 12px;
            gap: 12px;
            flex: 1 0 0;
            background: white;
            border-radius: 10px;
            max-height: 155px;
            .row {
                display: flex;
                justify-content: space-between;
                width: 100%;
            }
            .textCode {
                color: ${(p) => p.color};
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .textDate {
                color: #9b9b9b;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }
            .textName {
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .textModel {
                color: #9b9b9b;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .textAddress {
                color: #9b9b9b;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                max-width: 60%;
            }
            .textStatus {
                color: #06b417;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                display: flex;
                gap: 10px;
                .section-point {
                    color: #26c2a4;
                    position: relative;
                    span {
                        margin-right: 5px;
                        &:after {
                            content: "";
                            position: absolute;
                            right: -5px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 1px;
                            height: 10px;
                            background-color: #d7d7d7;
                        }
                    }
                }
            }
            .textStatusReject {
                color: #ff0000;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .textStatusPending {
                display: flex;
                gap: 3px;
                color: #f2bb3d;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .divider {
                width: 100%;
                border: 0.5px dashed #e1e1e1;
            }
        }
    }
`;
const StyledBtnUploadActivity = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: #fff;
    background-color: ${(p) => p.themeColor};
    // background: linear-gradient(342deg, rgba(162,26,115,1) 0%, rgba(227,62,59,1) 100%);
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 52px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
